document.querySelectorAll('.copy-button').forEach((button) => {
  button.addEventListener('click', async () => {
    const code = button.getAttribute('data-code') || '';
    try {
      await navigator.clipboard.writeText(code);
      button.setAttribute('data-copied', 'true');
      setTimeout(() => {
        button.setAttribute('data-copied', 'false');
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  });
});
